<div class="card contato">
  <div class="card-body">
    <div class="dados-contato" *ngIf="contato; else contatoNaoIdentificado">
      <header class="contato-cabecalho">
        <span class="contato-avatar" aria-hidden="true">{{(contato?.nome || '?').slice(0, 1)}}</span>
        <div class="contato-identidade">
          <div class="contato-linha-nome">
            <strong class="contato-nome">{{contato?.nome || 'Sem nome'}}</strong>
            <span class="contato-status" *ngIf="contato?.id || contato?.status; else novoCliente">
              <contato-status [contato]="contato"></contato-status>
            </span>
            <ng-template #novoCliente><span class="contato-selo-novo">Novo cliente</span></ng-template>
          </div>
          <span class="contato-telefone" *ngIf="contato?.telefone; else semTelefone">
            <i class="fab fa-whatsapp" aria-hidden="true"></i>
            <span>{{contato?.telefone | tel: contato?.codigoPais }}</span>
          </span>
          <ng-template #semTelefone><span class="contato-telefone contato-telefone-vazio">Sem telefone</span></ng-template>
        </div>
      </header>

      <section class="mia-painel" *ngIf="possuiModuloChatbot && statusMia" aria-label="Atendimento da Mia neste contato"
               [class.mia-ativa]="!desativarParaSempre && !atendente && !autoriaPendenteV4"
               [class.mia-bloqueada]="desativarParaSempre">
        <div class="mia-linha">
          <span class="mia-avatar" aria-hidden="true">
            <i class="fas fa-robot"></i>
            <span class="mia-avatar-ponto"></span>
          </span>
          <div class="mia-texto">
            <div class="mia-titulo">
              <strong>Mia</strong>
              <span class="mia-status" role="status" aria-live="polite">
                {{desativarParaSempre ? 'Bloqueada' : atendente ? 'Pausada' : autoriaPendenteV4 ? 'Suspensa' : 'Ativa'}}
              </span>
            </div>
            <p class="mia-descricao" *ngIf="desativarParaSempre">Não responde a este contato. Desligue o bloqueio abaixo para voltar a ativar.</p>
            <p class="mia-descricao" *ngIf="!desativarParaSempre && atendente">Atendimento manual. A Mia não está respondendo.</p>
            <p class="mia-descricao" *ngIf="!desativarParaSempre && !atendente && autoriaPendenteV4">Aguardando confirmar a origem de uma mensagem enviada para retomar o atendimento.</p>
            <p class="mia-descricao" *ngIf="!desativarParaSempre && !atendente && !autoriaPendenteV4">Respondendo automaticamente neste contato.</p>
          </div>
          <div class="mia-acao" *ngIf="!desativarParaSempre">
            <button type="button" class="mia-botao mia-botao-ativar" (click)="ativarChatBot()"
                    *ngIf="atendente" [disabled]="salvandoDesativacaoMia">
              <i class="fas fa-play" aria-hidden="true"></i> Ativar
            </button>
            <button type="button" class="mia-botao mia-botao-assumir" (click)="assumirControle()"
                    *ngIf="!atendente" [disabled]="salvandoDesativacaoMia" title="Pausa a Mia por 1 hora neste contato">
              <i class="fas fa-hand-paper" aria-hidden="true"></i> Assumir
            </button>
            <span class="mia-ajuda" *ngIf="!atendente">pausa de 1 hora</span>
          </div>
        </div>

        <label class="mia-bloqueio" [class.mia-bloqueio-salvando]="salvandoDesativacaoMia">
          <span class="mia-bloqueio-texto">
            <strong>Bloquear Mia neste contato</strong>
            <small>{{salvandoDesativacaoMia ? 'Salvando alteração…' : 'Ela não retoma sozinha enquanto o bloqueio estiver ligado.'}}</small>
          </span>
          <input name="desativarParaSempre" type="checkbox" role="switch" [ngModel]="desativarParaSempre"
                 [disabled]="salvandoDesativacaoMia" (ngModelChange)="ativouDesativouParaSempre($event)"/>
          <span class="mia-switch" aria-hidden="true"></span>
        </label>
      </section>

      <section class="contato-secao" *ngIf="exibirEndereco && contato?.enderecos?.length > 0" aria-label="Endereços">
        <h4 class="contato-secao-titulo">Endereços</h4>
        <div class="contato-endereco" *ngFor="let endereco of obtenhaEnderecosExibir(); let i = index">
          <span class="endereco-indice" aria-hidden="true">{{i + 1}}</span>
          <resumo-endereco [endereco]="endereco" [compacto]="true"></resumo-endereco>
        </div>
      </section>

      <section class="contato-secao" *ngIf="contato?.tags && contato.tags.length" aria-label="Etiquetas">
        <h4 class="contato-secao-titulo">Etiquetas</h4>
        <div class="contato-tags">
          <kendo-chip *ngFor="let tag of contato.tags" [label]="tag.nome" [removable]="false"></kendo-chip>
        </div>
      </section>

      <section class="contato-secao" aria-label="Últimas atividades"
               *ngIf="empresa?.modulos?.length > 0 && exibirUltimaVisita && ((possuiFidelidade && contato?.ultimaVisita) || (possuiPedidos && contato?.dataUltimoPedido))">
        <h4 class="contato-secao-titulo">Últimas atividades</h4>
        <dl class="contato-atividades">
          <div *ngIf="possuiFidelidade && contato?.ultimaVisita">
            <dt><i class="far fa-calendar" aria-hidden="true"></i> Última visita</dt>
            <dd>{{contato?.ultimaVisita | date: 'dd/MM/yyyy'}} <span>às {{contato?.ultimaVisita | date: 'HH:mm'}}</span></dd>
          </div>
          <div *ngIf="possuiPedidos && contato?.dataUltimoPedido">
            <dt><i class="fas fa-shopping-bag" aria-hidden="true"></i> Último pedido</dt>
            <dd>{{contato?.dataUltimoPedido | date: 'dd/MM/yyyy'}} <span>às {{contato?.dataUltimoPedido | date: 'HH:mm'}}</span></dd>
          </div>
        </dl>
      </section>
    </div>
    <ng-template #contatoNaoIdentificado><p class="contato-vazio">Consumidor não identificado</p></ng-template>
  </div>
</div>
